<template>
  <div id="table-header" class="tw-relative">
    <div class="sm:tw-hidden">
      <label :for="label"></label>
      <select
        class="tw-w-full tw-bg-gray-light tw-text-sm tw-rounded tw-p-4 tw-cursor-pointer tw-border-0 focus:tw-border-primary"
        name="header"
        id="header"
        v-model="selected"
      >
        <option
          class="tw-flex tw-items-center"
          v-for="(option, index) in options"
          :value="option"
          :key="index"
        >
          <p>
            {{ option }}
          </p>
        </option>
      </select>
      <img
        src="@/assets/img/chevron-down.svg"
        class="tw-absolute tw-right-2 tw-bottom-6"
        alt="chevron icon"
      />
    </div>
    <div class="tw-hidden sm:tw-block">
      <ul
        class="tw-flex tw-border-b tw-border-gray_dark tw-overflow-auto" :class="[removePadding ? null : 'lg:tw-px-12']"
      >
        <li
          class="tw-font-CircularStd-medium tw-font-medium tw-cursor-pointer tw-transition-all tw-duration-300 hover:tw-border-primary tw-py-4 tw-mr-14"
          :class="[
            tab === option ? 'tw-border-b-4 tw-border-primary' : 'tw-text-gray',
          ]"
          v-for="(option, index) in options"
          :key="index"
          @click="updateTab"
        >
          {{ option }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableHeader",

  emits: ["emitOption"],

  props: {
    options: { type: Array, default: () => [], required: true },
    label: { type: String, default: () => "", required: true },
    removePadding: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: "",
      tab: "",
    };
  },

  mounted() {
    if (this.$route.params.option === "secondary") {
      this.selected = "Secondaries";
      return;
    }
    if (this.$route.params.option === "tokens") {
      this.selected = "My Tokens";
      return;
    }
    if (this.$route.query.tab === "investments") {
      this.selected = "My Investments";
      return;
    }
    this.selected = this.options[0];
  },

  methods: {
    updateTab(event) {
      this.selected = event.target.innerText;
      this.tab = event.target.innerText;
    },

    emitOption(option) {
      this.$emit("emitOption", option);
    },
  },

  watch: {
    selected(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.tab = newValue;
        this.emitOption(newValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
